<template>
  <div id="page-layout">
    <div id="page-header">
      <div class="page-title-layout">
        <p>{{$t(`user.${pageMode}_list_title`)}}</p>
      </div>
      <button class="solid-button" type="button" v-on:click="addUser()">
        <i class="fas fa-plus"></i>
        {{$t(`user.${pageMode}_add`)}}
      </button>
    </div>
    <div v-bind:class="isClientList() ? 'grid grid-3' :'grid grid-2'" v-if="users.length > 0">
      <div class="column-title">{{ $t("user.last_name") }}</div>
      <div class="column-title" v-if="isClientList()">{{ $t("user.company") }}</div>
      <div class="column-title"></div>
    </div>
    <template v-for="user in users">
      <div v-bind:class="isClientList() ? 'grid row grid-3' :'grid row grid-2'">
        <div class="column">
          <div class="avatar-circle">
            <span class="initials">{{Utils.getInitials(user)}}</span>
          </div>
          <div class="default-text">{{user.displayName}}</div>
        </div>
        <div class="column" v-if="isClientList()">
          <div class="default-text">{{user.companyName}}</div>
        </div>
        <div class="actions">
          <button class="ghost-button blue-hoover" type="button" v-on:click="manageUser(user.id)">
            {{$t(`actions.manage_${pageMode}`)}}
          </button>
          <button class="ghost-button red-hoover" type="button" v-on:click="showModal(user)">{{$t("actions.delete")}}
          </button>
        </div>
      </div>
    </template>
    <simple-modal
      ref="modal"
      :model="selectedUser"
      v-on:confirm="deleteUser(selectedUser.id)"
      v-show="isModalVisible"
      @cancel="closeModal">
      <!--use #header instead of https://vuejs.org/v2/guide/components-slots.html#Deprecated-Syntax-->
      <template #header>
        <p class="modal-title">{{ $t(`user.${pageMode}_delete_modal_title`) }}</p>
      </template>
      <template #body="{model}">
        <div class="modal-layout">
          <p class="modal-content"
             v-html="$t(`user.${pageMode}_delete_modal_content`, {name: model.displayName})"></p>
          <div class="modal-select" v-if="!isClientList()">
            <p class="modal-content">{{ $t('user.admin_delete_modal_replacement') }}</p>
            <v-select class="small-input" v-model="selectedReplacement" :options="adminReplacementList"
                      :searchable="true"/>
          </div>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
  import simpleModal from "../components/simpleModal.vue";
  import userService from "../services/userService.js"
  import Utils from "../services/utils.js";

  const PageModes = {
    CLIENT: 'client',
    ADMIN: 'admin'
  };

  export default {
    props: {
      pageMode: {
        type: String,
        default: function () {
          return PageModes.CLIENT
        }
      },
    },
    watch: {
      '$route'(to, from) {
        if (to.params.pageMode !== this.pageMode) {
          this.loadUsers();
        }
      }
    },
    data() {
      return {
        Utils: Utils,
        users: [],
        selectedUser: {},
        selectedReplacement: {},
        adminReplacementList: [],
        isModalVisible: false
      };
    },
    components: {
      simpleModal
    },
    methods: {
      isClientList() {
        return this.pageMode === PageModes.CLIENT;
      },
      loadUsers() {
        this.users = [];
        const call = this.isClientList() ? userService.listClients : userService.listAdmins;
        call().then(users => {
          this.users = users;
        })
      },
      addUser() {
        const routeName = this.isClientList() ? 'clientCreate' : 'adminCreate';
        this.$router.push({name: routeName})
      },
      manageUser(userId) {
        const routeName = this.isClientList() ? 'clientManage' : 'adminManage';
        this.$router.push({name: routeName, params: {id: userId}})
      },
      deleteUser(userId) {
        const displayName = this.selectedUser.displayName;
        const call = this.isClientList() ?
          userService.deleteClient(userId) :
          userService.deleteAdmin(userId, this.selectedReplacement.value);

        call.then((response) => {
          this.$store.dispatch('alert/success', this.$t("alerts.delete_success", {name: displayName}));
          this.loadUsers(); // refresh
        }).catch((error) => {
          this.$store.dispatch('alert/error', {
            message: this.$t("alerts.delete_error", {name: displayName}),
            error: error
          });
        });
        this.closeModal();
      },
      showModal(user) {
        this.adminReplacementList = [];
        this.selectedReplacement = {value: 0};
        this.selectedUser = user;

        if (!this.isClientList()) { /// admin list
          const filteredList = this.users.filter(u => u.id !== user.id); // all but selected one
          if (filteredList.length > 0) {
            this.adminReplacementList = filteredList.map(admin => {
              return {label: admin.displayName, value: admin.id}
            });
          }
        }

        this.isModalVisible = true;
      },
      closeModal() {
        this.selectedUser = {};
        this.isModalVisible = false;
      },
    },
    mounted() {
      this.loadUsers();
    }
  }
</script>
<style lang="scss" scoped>
  @import '../style/list.scss';

  #page-layout {
    display: grid;
    grid-template-columns: 15% [content] auto 15%;
  }

  #page-header {
    @extend %common-header;
    justify-content: space-between;
  }

  .grid-2 {
    grid-template-columns: auto 300px;
  }

  .grid-3 {
    grid-template-columns: 1fr 2fr 300px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/listUsers.vue